<template>
  <div class="w-screen max-w-[80rem]" id="aero">
    <div class="glass-carbon relative flex h-full flex-col overflow-y-scroll shadow-xl">
      <div
        class="grid grid-cols-12 pt-6 px-6"
        :class="{
          'pb-20 lg:pb-6 xl:pb-20': page === 'Operações',
          'pb-36 lg:pb-20': page !== 'Operações',
        }"
      >
        <!-- **************** SIDEBAR **************** -->
        <div class="col-span-12 mr-6 hidden xl:col-span-2 xl:block">
          <div class="sticky top-0">
            <div class="py-10">
              <span
                class="text-ontick-carbon-900 h-6 w-6 cursor-pointer hover:text-gray-500 dark:text-gray-400"
                @click="$emit('close')"
                v-html="$icons.arrow_left"
              ></span>
            </div>

            <!-- ADD BUTTON -->
            <template>
              <button
                v-if="product.marketplace_status === 'ADDED'"
                class="ghost-button border-ontick-blue-600 text-ontick-blue-600"
              >
                <span> Adicionada </span>
                <i v-html="$icons.material_check"></i>
              </button>
              <button
                v-else-if="product.marketplace_status === 'HIDDEN'"
                class="ghost-button border-ontick-yellow-900 text-ontick-yellow-900"
              >
                <span> Arquivada </span>
                <i v-html="$icons.material_arquive"></i>
              </button>
              <ontick-button
                v-else-if="!disableAdd"
                @click.native="subscription()"
                color="secondary"
                class="mb-10 w-full uppercase"
              >
                Adicionar
              </ontick-button>
            </template>

            <!-- NAVIGATION -->
            <template>
              <nav>
                <li
                  v-for="(item, index) in sidebar"
                  :key="index"
                  :class="
                    active_index == index
                      ? 'text-ontick-blue-800 dark:text-white'
                      : 'text-ontick-carbon-900 dark:text-gray-400'
                  "
                  class="flex cursor-pointer items-center py-2 text-sm font-medium transition-all duration-100 ease-in-out"
                  @click="
                    () => {
                      page = item;
                      active_index = index;
                      paginationCurrentPage = 1;
                    }
                  "
                >
                  <!-- <a @click="scrollToAnchorPoint(item, index)"> {{ item }} </a> -->
                  <span>{{ item }}</span>
                  <!-- <a
                    @click="
                      () => {
                        page = item;
                        active_index = index;
                        paginationCurrentPage = 1;
                      }
                    "
                  >
                    {{ item }}
                  </a> -->
                </li>
              </nav>

              <div class="relative z-0 flex rounded-md py-12 shadow-sm" v-if="!disablePagination">
                <button
                  @click="$emit('pagination', 'previous')"
                  type="button"
                  :disabled="pagination == 0 ? true : false"
                  content="Estrátegia anterior"
                  v-tippy="{ arrow: true, theme: 'green' }"
                  :class="
                    pagination == 0
                      ? 'text-ontick-carbon-900 cursor-not-allowed dark:text-gray-400'
                      : 'text-ontick-blue-600'
                  "
                  class="border-ontick-steel-300 bg-ontick-steel-300 hover:bg-ontick-steel-400 dark:hover:bg-ontick-steel-600 dark:border-ontick-carbon-500 dark:bg-ontick-steel-700 relative inline-flex w-full items-center justify-center rounded-l-md border px-2 py-2 text-sm font-medium focus:z-10 focus:outline-none"
                >
                  <span class="sr-only">Previous</span>
                  <span v-html="$icons.chevron_left"></span>
                </button>
                <button
                  @click="$emit('pagination', 'next')"
                  type="button"
                  :disabled="pagination < index_last ? false : true"
                  content="Próxima estrátegia"
                  v-tippy="{ arrow: true, theme: 'green' }"
                  :class="
                    pagination < index_last
                      ? 'text-ontick-blue-500'
                      : 'text-ontick-carbon-900 cursor-not-allowed dark:text-gray-400'
                  "
                  class="hover:bg-ontick-steel-400 dark:hover:bg-ontick-steel-600 border-ontick-steel-300 bg-ontick-graphite-100 dark:border-ontick-carbon-500 dark:bg-ontick-steel-700 relative -ml-px inline-flex w-full items-center justify-center rounded-r-md border px-2 py-2 text-sm font-medium focus:z-10 focus:outline-none"
                >
                  <span class="sr-only">Next</span>
                  <span v-html="$icons.chevron_right"></span>
                </button>
              </div>
            </template>
          </div>
        </div>
        <!-- /end **************** SIDEBAR **************** -->

        <!-- MAIN SECTION -->
        <div class="col-span-12 space-y-3 xl:col-span-10">
          <!-- HEADER -->
          <section
            class="bg-ontick-graphite-100 dark:bg-ontick-carbon-500 sticky top-0 z-10 bg-opacity-90 py-1 pb-0 backdrop-blur-sm backdrop-opacity-90 backdrop-filter md:pb-3 xl:pt-6"
          >
            <i
              class="text-ontick-carbon-900 my-2 block h-6 w-6 cursor-pointer hover:text-gray-500 dark:text-gray-400 xl:hidden"
              @click="$emit('close')"
              v-html="$icons.arrow_left"
            ></i>
            <div class="space-y-4 md:space-y-6">
              <div class="space-y-2">
                <transition name="slide-fade" mode="out-in">
                  <div class="flex items-center space-x-2">
                    <marketplace-favorite-component
                      :id_favorite="strategy_id"
                      :active="
                        favorite_marketplace.msg == 'Nenhuma preferência encontrada'
                          ? false
                          : favorite_marketplace.some((item) => item.product_id == product_id)
                      "
                    />
                    <dt
                      :key="product.strategy_name"
                      class="leading-1 text-ontick-carbon-900 truncate text-3xl font-bold dark:text-gray-300"
                    >
                      {{ product.strategy_name }}
                    </dt>
                  </div>
                </transition>

                <div class="flex-none justify-between space-y-1 xl:flex xl:space-y-0">
                  <div class="text-ontick-carbon-900 text-sm dark:text-gray-400">
                    Capital Recomendado: {{ product.min_capital | currency }}
                  </div>
                  <div class="ml-0 text-xs text-gray-500">
                    Criada em:
                    {{ moment(product.strategy_create_date).format("LLL") }}
                  </div>
                </div>
              </div>
              <dd class="mt-3 flex items-baseline space-x-3 text-sm md:mt-2">
                <span
                  class="bg-ontick-blue-900 dark:text-ontick-blue-500 rounded px-3 py-1 text-xs text-gray-50"
                  content="Ativo"
                  v-tippy="{ arrow: true, theme: 'green', placement: 'bottom' }"
                >
                  {{ product.strategy_symbol }}</span
                >
                <span
                  :class="
                    product.strategy_risk == 'BAIXO'
                      ? 'bg-ontick-green-900'
                      : product.strategy_risk == 'MEDIO'
                        ? 'bg-ontick-yellow-900'
                        : 'bg-ontick-red-900'
                  "
                  class="rounded px-3 py-1 text-xs"
                  content="Risco"
                  v-tippy="{ arrow: true, theme: 'green', placement: 'bottom' }"
                >
                  <span
                    :class="
                      product.strategy_risk == 'BAIXO'
                        ? 'dark:text-ontick-green-500 text-gray-50'
                        : product.strategy_risk == 'MEDIO'
                          ? 'dark:text-ontick-yellow-500 text-gray-50'
                          : 'dark:text-ontick-red-500 text-gray-50'
                    "
                  >
                    {{ product.strategy_risk }}</span
                  >
                </span>
                <span
                  :class="colorStatus(product.strategy_type)"
                  class="rounded px-3 py-1 text-xs"
                  content="Tipo"
                  v-tippy="{ arrow: true, theme: 'green', placement: 'bottom' }"
                >
                  {{ product.strategy_type }}
                </span>
                <span
                  :class="colorStyle(product.strategy_style)"
                  class="rounded px-3 py-1 text-xs"
                  content="Modo de operação"
                  v-tippy="{ arrow: true, theme: 'green', placement: 'bottom' }"
                >
                  {{ product.strategy_style }}
                </span>
              </dd>
              <!-- +++++++++++++++++++++++++++++++++ -->

              <!-- NAVIGATION -->
              <template>
                <div class="flex gap-3 justify-center md:justify-start xl:hidden">
                  <button
                    v-for="(item, index) in sidebar"
                    :key="index"
                    :class="
                      active_index == index
                        ? 'text-ontick-blue-800 dark:text-white border-b-2 border-ontick-blue-500'
                        : 'text-ontick-carbon-900 dark:text-gray-400'
                    "
                    class="w-fit p-1 cursor-pointer text-base font-medium transition-all duration-100 ease-in-out"
                    @click="
                      () => {
                        page = item;
                        active_index = index;
                        paginationCurrentPage = 1;
                      }
                    "
                  >
                    <span>{{ item }}</span>
                  </button>
                </div>
              </template>

              <!-- +++++++++++++++++++++++++++++++++ -->
              <template v-if="page !== 'Informações'">
                <div
                  class="mt-3 flex flex-col items-baseline justify-between space-y-1 text-sm md:flex-row md:space-y-0 md:space-x-3"
                >
                  <div class="block w-full space-y-1 md:w-auto">
                    <p class="hidden text-sm font-normal md:block">Período</p>
                    <div class="relative w-full">
                      <VueCtkDateTimePicker
                        v-model="select_period"
                        label="Selecione o periodo"
                        :range="true"
                        :dark="true"
                        :inline="false"
                        locale="pt-BR"
                        color="#293241"
                        :noClearButton="true"
                        button-now-translation="Fechar"
                        :custom-shortcuts="customShortcuts"
                        formatted="DD/MM/YYYY"
                        @validate="dateSelected($event)"
                        :no-value-to-custom-elem="true"
                        class="w-full md:w-64"
                      >
                      </VueCtkDateTimePicker>
                      <span class="absolute inset-y-2.5 right-2" v-html="$icons.calendar" />
                    </div>
                  </div>
                  <div class="block w-full space-y-1 md:w-auto">
                    <p class="hidden text-sm font-normal md:block">Análise</p>
                    <div class="relative h-[42px] w-full">
                      <treeselect
                        :multiple="false"
                        :options="analysisOptions"
                        :show-count="true"
                        :searchable="false"
                        :clearable="false"
                        placeholder="Selecione seu período de análise"
                        v-model="analysis_id"
                        @select="analysisSelect"
                        class="h-full w-full rounded-md md:w-64"
                      >
                        <div
                          slot="option-label"
                          slot-scope="{ node, labelClassName }"
                          :class="labelClassName"
                          class="py-2"
                        >
                          <div
                            class="flex items-center justify-between"
                            v-for="(item, index) in analysisOptions"
                            :key="index"
                          >
                            <div class="space-x-3" v-if="node.id == item.id">
                              <span :class="['text-sm', node.id === 4 ? 'text-gray-400' : 'text-gray-300']">{{
                                node.label
                              }}</span>
                            </div>
                          </div>
                        </div>
                        <div slot="value-label" slot-scope="{ node }" class="w-full">
                          <div
                            class="flex items-center justify-between"
                            v-for="(item, index) in analysisOptions"
                            :key="index"
                          >
                            <div class="space-x-3" v-if="node.id == item.id">
                              <span class="text-sm text-gray-300">{{ node.label }}</span>
                            </div>
                          </div>
                        </div>
                      </treeselect>
                    </div>
                  </div>
                </div>
              </template>
              <!-- +++++++++++++++++++++++++++++++++ -->
              <!-- +++++++++++++++++++++++++++++++++ -->
              <!-- <div class="border border-red-500 px-3 py-1.5">
                <p class="text-red-500 text-sm font-medium">{{ analysis_id }}</p>
                <p class="text-red-500 text-sm font-medium">{{ select_period }}</p>
                <p class="text-red-500 text-sm font-medium">{{ periodHeatmap }}</p>
                <p class="text-red-500 text-sm font-medium">
                  {{ heatmapChart.periodMonth }}/{{ heatmapChart.periodYear }}
                </p>
              </div> -->
              <!-- +++++++++++++++++++++++++++++++++ -->
              <!-- +++++++++++++++++++++++++++++++++ -->
            </div>
          </section>
          <div class="col-span-12 space-y-16 xl:col-span-10 py-4">
            <!-- TODO: SUMMARY TABLE -->
            <template v-if="['Resumo', 'Operações'].includes(page)">
              <section ref="Resumo" class="space-y-12">
                <div class="space-y-8">
                  <transition name="slide-fade" mode="out-in">
                    <marketplace-table
                      v-if="pnl_table.length > 0 || pnlError != ''"
                      :product="pnl_table"
                      :pnlError="pnlError"
                      :year="years_pnl_table"
                      @selectedPeriod="selectedPeriod"
                      @change="changeTablePNL"
                    />
                    <placeholder-card-component v-if="Object.keys(pnl_table).length == 0 && pnlError === ''" :qtd="3" />
                  </transition>
                </div>

                <template v-if="page === 'Resumo'">
                  <template v-if="Object.keys(equity_curve).length > 0">
                    <chart
                      :menu="charts"
                      :equityCurve="equity_curve"
                      :splitDate="split_equity_curve"
                      :analysisType="getAnalysisType()"
                      :heatmapChart="heatmapChart"
                      @selectedPeriod="selectedPeriod"
                      @selectedChart="selectedChart"
                    />
                  </template>
                  <placeholder-card-component v-else :qtd="4" />
                </template>
              </section>
            </template>
            <!-- TODO: STATISTICS -->
            <template v-if="page === 'Resumo'">
              <section ref="Estatísticas" class="space-y-6">
                <h2 class="text-ontick-carbon-900 text-3xl font-bold dark:text-gray-300">Estatísticas</h2>

                <div class="relative">
                  <div
                    class="bg-ontick-steel-200 dark:bg-ontick-graphite-500 absolute inset-0 flex items-center justify-center rounded-lg bg-opacity-90 backdrop-blur-sm backdrop-filter"
                    v-show="statisticsIsEmpty && showMask"
                  >
                    <div
                      class="text-ontick-carbon-900 flex flex-col items-center justify-center space-y-4 dark:text-gray-300"
                    >
                      <div class="absolute top-6 right-6">
                        <button @click="showMask = false">
                          <i v-html="$icons.close"></i>
                        </button>
                      </div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-16 w-16 xl:h-20 xl:w-20"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <dl class="space-y-4 px-6 text-center sm:w-96 sm:px-0">
                        <dt class="font-bold xl:text-2xl">Dados insuficientes</dt>
                        <dd class="text-sm xl:text-base">
                          Essa estratégia ainda não possui dados para o período selecionado.
                        </dd>
                      </dl>
                    </div>
                  </div>
                  <div class="mt-6 grid grid-cols-2 gap-3 text-center xl:grid-cols-4 xl:gap-6">
                    <template
                      v-if="['Total', 'Paper trade', 'Backtest', 'Personalizado'].includes(getSelectedMenuStatistics())"
                    >
                      <marketplace-details-statistics-card-component
                        title="Resultado"
                        :value="product_statistic.percent_result"
                        type="percentage"
                      />
                    </template>

                    <template
                      v-if="['Total', 'Paper trade', 'Backtest', 'Personalizado'].includes(getSelectedMenuStatistics())"
                    >
                      <marketplace-details-statistics-card-component
                        title="Resultado Líquido"
                        :value="product_statistic.net_result"
                        type="cash"
                      />
                    </template>

                    <template
                      v-if="['Total', 'Paper trade', 'Backtest', 'Personalizado'].includes(getSelectedMenuStatistics())"
                    >
                      <marketplace-details-statistics-card-component
                        title="Lucro Bruto"
                        :value="product_statistic.profits"
                        type="cash"
                      />
                    </template>

                    <template
                      v-if="['Total', 'Paper trade', 'Backtest', 'Personalizado'].includes(getSelectedMenuStatistics())"
                    >
                      <marketplace-details-statistics-card-component
                        title="Perda Bruta"
                        :value="product_statistic.losses"
                        type="cash"
                      />
                    </template>

                    <template
                      v-if="['Total', 'Paper trade', 'Backtest', 'Personalizado'].includes(getSelectedMenuStatistics())"
                    >
                      <marketplace-details-statistics-card-component
                        title="Taxa de Acerto"
                        :value="product_statistic.win_rate"
                        type="percentage_nutral"
                      />
                    </template>

                    <template
                      v-if="['Total', 'Paper trade', 'Backtest', 'Personalizado'].includes(getSelectedMenuStatistics())"
                    >
                      <marketplace-details-statistics-card-component
                        title="Dias Operados"
                        :value="product_statistic.num_days"
                      />
                    </template>

                    <template
                      v-if="['Total', 'Paper trade', 'Backtest', 'Personalizado'].includes(getSelectedMenuStatistics())"
                    >
                      <marketplace-details-statistics-card-component
                        title="Dias com Ganho"
                        :value="product_statistic.positive_days"
                      />
                    </template>

                    <template
                      v-if="['Total', 'Paper trade', 'Backtest', 'Personalizado'].includes(getSelectedMenuStatistics())"
                    >
                      <marketplace-details-statistics-card-component
                        title="Dias com Perda"
                        :value="product_statistic.negative_days"
                      />
                    </template>

                    <template
                      v-if="['Total', 'Paper trade', 'Backtest', 'Personalizado'].includes(getSelectedMenuStatistics())"
                    >
                      <marketplace-details-statistics-card-component
                        title="Fator de Lucro"
                        :value="product_statistic.profit_factor"
                        suffix="x"
                      />
                    </template>

                    <template
                      v-if="['Total', 'Paper trade', 'Backtest', 'Personalizado'].includes(getSelectedMenuStatistics())"
                    >
                      <marketplace-details-statistics-card-component
                        title="Drawdown"
                        :value="product_statistic.drawdown"
                        type="percentage"
                      />
                    </template>

                    <template
                      v-if="['Total', 'Paper trade', 'Backtest', 'Personalizado'].includes(getSelectedMenuStatistics())"
                    >
                      <marketplace-details-statistics-card-component
                        title="Perda Média Diária"
                        :value="product_statistic.avg_loss_per_day"
                        type="cash"
                      />
                    </template>

                    <template
                      v-if="['Total', 'Paper trade', 'Backtest', 'Personalizado'].includes(getSelectedMenuStatistics())"
                    >
                      <marketplace-details-statistics-card-component
                        title="Ganho Médio Diário"
                        :value="product_statistic.avg_gain_per_day"
                        type="cash"
                      />
                    </template>

                    <template v-if="['Paper trade'].includes(getSelectedMenuStatistics())">
                      <marketplace-details-statistics-card-component
                        title="Total de Operações"
                        :value="product_statistic.total_trades"
                      />
                    </template>

                    <template v-if="['Paper trade'].includes(getSelectedMenuStatistics())">
                      <marketplace-details-statistics-card-component
                        title="Operações de Compra"
                        :value="product_statistic.long_trades"
                      />
                    </template>

                    <template v-if="['Paper trade'].includes(getSelectedMenuStatistics())">
                      <marketplace-details-statistics-card-component
                        title="Operações de Venda"
                        :value="product_statistic.short_trades"
                      />
                    </template>
                  </div>
                </div>
              </section>
            </template>

            <template v-if="page === 'Informações'">
              <!-- TODO: DEVELOPER -->
              <section ref="Desenvolvedor">
                <h2 class="text-ontick-carbon-900 pb-4 text-3xl font-bold dark:text-gray-300">Desenvolvedor</h2>
                <h3 class="text-ontick-carbon-900 dark:text-gray-400" v-if="$route.name === 'Analistas XP'">
                  Analistas Grupo XP
                </h3>
                <vue-markdown
                  :toc="true"
                  :source="product.strategy_developer"
                  class="text-ontick-carbon-900 dark:text-gray-400"
                >
                </vue-markdown>
                <vue-markdown
                  v-if="$route.name !== 'Analistas XP'"
                  :toc="true"
                  :source="product?.product_description?.developer"
                  class="text-ontick-carbon-900 dark:text-gray-400"
                >
                </vue-markdown>
              </section>

              <!-- TODO: DESCRIPTION -->
              <section ref="Descrição">
                <h2 class="text-ontick-carbon-900 pb-4 text-3xl font-bold dark:text-gray-300">Descrição</h2>
                <vue-markdown
                  :toc="true"
                  :source="product?.product_description?.description"
                  class="text-ontick-carbon-900 dark:text-gray-400"
                >
                </vue-markdown>
              </section>

              <!-- TODO: STRATEGY -->
              <section ref="Estratégia">
                <h2 class="text-ontick-carbon-900 pb-4 text-3xl font-bold dark:text-gray-300">Estratégia</h2>
                <vue-markdown
                  :toc="true"
                  :source="product.product_strategy"
                  class="text-ontick-carbon-900 dark:text-gray-400"
                >
                </vue-markdown>
              </section>

              <!-- TODO: DISCLAIMER -->
              <section ref="Disclaimer">
                <h2 class="text-ontick-carbon-900 pb-4 text-3xl font-bold dark:text-gray-300">Disclaimer</h2>
                <vue-markdown
                  :toc="true"
                  :source="'Investimentos e estratégias de investimento apresentam riscos potenciais e retornos. Desempenhos passados não são indicativos de resultados futuros. Nós não garantimos qualquer resultado específico ou lucro. Você deve estar ciente dos riscos e estar disposto a aceitá-los para investir nos mercados. Qualquer decisão de investimento que você tome deve ser baseada em sua própria diligência e consideração de suas circunstâncias pessoais, incluindo, mas não se limitando a, sua tolerância ao risco, situação financeira e objetivos de investimento. Nós não nos responsabilizamos por quaisquer perdas que você possa sofrer como resultado do uso das informações, dados ou serviços da plataforma. Ao utilizar nosso site e nossos serviços, você concorda com este aviso de isenção de responsabilidade e assume total responsabilidade por suas decisões e ações.'"
                  class="text-ontick-carbon-900 dark:text-gray-400"
                >
                </vue-markdown>
              </section>
            </template>

            <!-- TODO: TRADES -->
            <template v-if="page === 'Operações'">
              <section ref="Operações">
                <h2 class="text-ontick-carbon-900 pb-4 text-3xl font-bold dark:text-gray-300">Operações</h2>
                <div class="relative overflow-hidden pb-16 xl:pb-4">
                  <marketplace-table-operation-component
                    :data="orders_position"
                    :currentPage="paginationCurrentPage"
                    @changePage="changePage"
                  />
                </div>
              </section>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div
      class="bg-ontick-carbon-500 absolute bottom-14 lg:bottom-0 flex w-full items-center space-x-3 pt-3 pb-5 lg:pb-3 px-6 xl:hidden"
      v-if="!disablePagination"
    >
      <ontick-button v-if="!disableAdd" @click.native="subscription()" color="secondary" class="w-full uppercase">
        Assinar
      </ontick-button>
      <span class="relative z-0 flex rounded-md shadow-sm">
        <button
          @click="$emit('pagination', 'previous')"
          type="button"
          :disabled="pagination == 0 ? true : false"
          content="Estrátegia anterior"
          v-tippy="{ arrow: true, theme: 'green' }"
          :class="
            pagination == 0 ? 'text-ontick-carbon-900 cursor-not-allowed dark:text-gray-400' : 'text-ontick-blue-600'
          "
          class="border-ontick-carbon-500 bg-ontick-steel-700 hover:bg-ontick-steel-600 relative inline-flex w-full items-center justify-center rounded-l-md border px-2 py-2 text-sm font-medium focus:z-10 focus:outline-none"
        >
          <span class="sr-only">Previous</span>
          <span v-html="$icons.chevron_left"></span>
        </button>
        <button
          @click="$emit('pagination', 'next')"
          type="button"
          :disabled="pagination >= index_last"
          content="Próxima estrátegia"
          v-tippy="{ arrow: true, theme: 'green' }"
          :class="
            pagination < index_last
              ? 'text-ontick-blue-500'
              : 'text-ontick-carbon-900 cursor-not-allowed dark:text-gray-400'
          "
          class="border-ontick-carbon-500 bg-ontick-steel-700 hover:bg-ontick-steel-600 relative -ml-px inline-flex w-full items-center justify-center rounded-r-md border px-2 py-2 text-sm font-medium focus:z-10 focus:outline-none"
        >
          <span class="sr-only">Next</span>
          <span v-html="$icons.chevron_right"></span>
        </button>
      </span>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";

import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

import EventBus from "@/app/shared/utils/event_bus.js";

import moment from "moment";

const customShortcuts = [
  { key: "thisDay", label: "Hoje", value: "day" },
  { key: "thisWeek", label: "Essa semana", value: "isoWeek" },
  { key: "lastWeek", label: "Semana anterior", value: "-isoWeek" },
  { key: "last7Days", label: "Últimos 7 dias", value: 7 },
  { key: "last30Days", label: "Últimos 30 dias", value: 30 },
  { key: "thisMonth", label: "Esse mês", value: "month" },
  { key: "lastMonth", label: "Mês anterior", value: "-month" },
  { key: "thisYear", label: "Esse ano", value: "year" },
  // { key: "lastYear", label: "Ano anterior", value: "-year" },
];

const typeOfAnalysis = {
  TOTAL_PERIOD: "Período total",
  BACKTEST: "Backtest",
  PAPER_TRADE: "Paper trade",
  CUSTOM_PERIOD: "Período personalizado",
};

export default {
  components: {
    Treeselect,
    VueCtkDateTimePicker,

    MarketplaceDetailsStatisticsCardComponent: () =>
      import("../../components/details/marketplace-details-statistics-card.component.vue"),

    Chart: () => import("@/app/modules/marketplace/components/details/marketplace-details-charts.component.vue"),
    MarketplaceTable: () =>
      import("@/app/modules/marketplace/components/details/marketplace-details-table.component.vue"),
    // MarketplaceTabComponent: () =>
    //   import("../../components/details/marketplace.tabb.component.vue"),
    MarketplaceOperationComponent: () => import("../../components/details/marketplace-operation.component.vue"),

    MarketplaceDetailsCardComponent: () => import("../../components/details/marketplace-details-card.component.vue"),
    PlaceholderCardComponent: () => import("../../../../shared/components/placeholder/placeholder-card.component.vue"),
    MarketplaceFavoriteComponent: () =>
      import("../../components/products/favorite/marketplace-favorite-heart.component.vue"),
    VueMarkdown: () => import("vue-markdown"),

    DetailsPortfolio: () => import("../../components/details/marketplace-portfolio.component.vue"),

    MarketplaceDetailsHeatmapComponent: () =>
      import("../../components/details/marketplace-details-heatmap.component.vue"),

    MarketplaceTableOperationComponent: () =>
      import("../../components/details/marketplace-table-operation.component.vue"),
  },

  props: {
    active: {
      type: Boolean,
      default: false,
    },
    strategy_id: {
      type: Number,
      default: 0,
    },
    product_id: {
      type: Number,
      default: 0,
    },
    marketplace_status: {
      type: String,
    },
    pagination: {
      type: Number,
    },
    index_last: {
      type: Number,
    },
    disableAdd: { type: Boolean, default: false },
    disablePagination: { type: Boolean, default: false },
    product_listed: { type: String },
  },

  data() {
    return {
      showMask: true,
      product: {},
      heatmap_every_year: [],
      equity_curve: [],
      split_equity_curve: null,
      product_statistic: {},
      pnl_table: [],
      years_pnl_table: [],
      pnlError: "",
      charts: [
        { label: "Linha", active: true },
        { label: "Barra", active: false },
        { label: "Heatmap", active: false },
      ],
      menuStatistics: [
        { label: "Total", active: true },
        { label: "Paper trade", active: false },
        { label: "Backtest", active: false },
        { label: "Personalizado", active: false },
      ],

      // sidebar: ["Resumo", "Estatísticas", "Descrição", "Estratégia", "Desenvolvedor", "Operações"],
      sidebar: ["Resumo", "Operações", "Informações"],
      page: "Resumo",
      active_index: 0,
      // active_index_menu: 0,
      investment_data: {
        ranking: 0,
        running: 0,
        num: 0,
        last_update: "",
      },
      orders_position: {},
      observer: null,

      // período
      select_period: {
        start: new Date(),
        end: new Date(),
      },
      customShortcuts: customShortcuts,
      //

      periodHeatmap: {
        start_period: new Date(),
        end_period: new Date(),
      },

      analysis_id: 1,

      analysisOptions: [
        { label: typeOfAnalysis.TOTAL_PERIOD, id: 1 },
        { label: typeOfAnalysis.BACKTEST, id: 2 },
        { label: typeOfAnalysis.PAPER_TRADE, id: 3 },
        { label: typeOfAnalysis.CUSTOM_PERIOD, id: 4, isDisabled: true },
      ],

      heatmapChart: {
        data: [],
        periodYear: "ALL",
        periodMonth: "ALL",
      },

      paginationCurrentPage: 1,

      selectedTypeChart: "Linha",

      resultTypePNLTable: "FIN_RESULT",
    };
  },

  created() {
    this.$nextTick(() => {
      this.requestDetailsV2(this.strategy_id);
      this.requestPerformanceV2(this.strategy_id);
      this.getStatsV2(this.strategy_id);
    });
  },

  watch: {
    pagination: {
      deep: true,
      handler(value) {
        this.years_pnl_table = [];
        this.requestDetailsV2(this.strategy_id);
        this.requestPerformanceV2(this.strategy_id);
        this.getStatsV2(this.strategy_id);
        return value;
      },
    },
    page: {
      deep: true,
      handler(value) {
        if (value === "Operações") {
          this.listOperationsV2(this.strategy_id);
        }
        return value;
      },
    },
    strategy_id: {
      deep: true,
      handler(value) {
        this.$nextTick(() => {
          this.requestDetailsV2(value);
          this.requestPerformanceV2(value);
          if (this.page === "Operações") {
            this.listOperationsV2(value);
          }
          this.getStatsV2(value);
          return value;
        });
      },
    },
    analysis_id: {
      deep: true,
      handler(value) {
        this.$nextTick(() => {
          this.requestDetailsV2(this.strategy_id);
          if (this.selectedTypeChart != "Heatmap") {
            this.requestPerformanceV2(this.strategy_id);
          }
          this.getStatsV2(this.strategy_id);
          return value;
        });
      },
    },
  },

  computed: {
    ...mapState({
      accountTypes: (state) => state.accountTypes,
      favorite_marketplace: (state) => state.marketplace.favorite_marketplace,
    }),
    ...mapGetters({ getSelectedAccount: "accountTypes/getSelectedAccount" }),
    statisticsIsEmpty() {
      // checa se todos os valores de product_statistics são undefined
      if (Object.values(this.product_statistic).every((item) => item == undefined)) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    getDateRange(firstDate, lastDate) {
      if (moment(firstDate, "YYYY-MM-DD").isSame(moment(lastDate, "YYYY-MM-DD"), "day")) return [lastDate];
      let date = firstDate;
      const dates = [moment(date).format("YYYY-MM-DD")];
      do {
        date = moment(date).add(1, "day");
        dates.push(date.format("YYYY-MM-DD"));
      } while (moment(date).isBefore(moment(lastDate).subtract(1, "day")));
      return dates;
    },

    async subscription() {
      if (["MARKETPLACE", "EXTENSION_ONLY"].includes(this.product_listed)) {
        this.trackSubscription();
        try {
          const res = await this.$api.post(this.$endpoint.ADD_MARKETPLACE_STRATEGY, {
            product_id: this.product_id,
            strategy_id: this.strategy_id,
            account_id: this.getSelectedAccount.account_id,
          });

          await this.$swal({
            title: "Sucesso",
            text: this.$filters.capitalize(res.data.msg),
            icon: "success",
            iconHtml: this.$icons.swal_success,
            timer: 3000,
            timerProgressBar: true,
          });
          this.$router.push({ path: "/investments" });
        } catch (err) {
          if (
            this.$route.name === "Analistas XP" &&
            err.data.msg === "Assine o plano PRO para poder utilizar esta estratégia"
          ) {
            this.$emit("openVideoModal");
            this.$emit("close");
          } else if (typeof err.data === "string") {
            this.$swal("Erro", this.$filters.capitalize(err.data), "error");
          } else {
            this.$swal("Erro", this.$filters.capitalize(err.data.msg), "error");
          }
        }
      } else if (["EXTENSION", "NOT_LISTED"].includes(this.product_listed)) {
        if (this.getSelectedAccount.account_type === "CONTEST") {
          this.trackSubscription();
          try {
            const res = await this.$api.post(this.$endpoint.ADD_EXTENSION_STRATEGY, {
              product_id: this.product_id,
              strategy_id: this.strategy_id,
              account_id: this.getSelectedAccount.account_id,
            });
            await this.$swal({
              title: "Sucesso",
              text: this.$filters.capitalize(res.data.msg),
              icon: "success",
              iconHtml: this.$icons.swal_success,
              timer: 3000,
              timerProgressBar: true,
            });
            this.$router.push({ path: "/investments" });
          } catch (err) {
            if (typeof err.data === "string") {
              this.$swal("Erro", this.$filters.capitalize(err.data), "error");
              return;
            }
            if (err.data.action === "REDIRECT_SUBSCRIPTION") {
              this.$router.push({
                name: "Detalhes da extensão",
                params: {
                  partner_name: this.product.partner_name,
                  extension_group: this.product.extension_group,
                },
              });
              return;
            }
            this.$swal("Erro", this.$filters.capitalize(err.data.msg), "error");
          }
        } else if (this.marketplace_status === "EXTENSION") {
          this.$router.push({
            name: "Detalhes da extensão",
            params: {
              partner_name: this.product.partner_name,
              extension_group: this.product.extension_group,
            },
          });
        } else {
          this.trackSubscription();
          try {
            const res = await this.$api.post(this.$endpoint.ADD_EXTENSION_STRATEGY, {
              product_id: this.product_id,
              strategy_id: this.strategy_id,
              account_id: this.getSelectedAccount.account_id,
            });

            await this.$swal({
              title: "Sucesso",
              text: this.$filters.capitalize(res.data.msg),
              icon: "success",
              iconHtml: this.$icons.swal_success,
              timer: 3000,
              timerProgressBar: true,
            });
            this.$router.push({ path: "/investments" });
          } catch (err) {
            if (typeof err.data === "string") {
              this.$swal("Erro", this.$filters.capitalize(err.data), "error");
              return;
            }
            if (err.data.action === "REDIRECT_SUBSCRIPTION") {
              this.$router.push({
                name: "Detalhes da extensão",
                params: {
                  partner_name: this.product.partner_name,
                  extension_group: this.product.extension_group,
                },
              });
              return;
            }
            this.$swal("Erro", this.$filters.capitalize(err.data.msg), "error");
          }
        }
      }
    },

    trackSubscription() {
      this.$gtm.trackEvent({
        event: "interaction", // Event type [default = 'interaction'] (Optional)
        category: "Assinatura",
        action: "click",
        label: "Assinatura iniciada",
        value: `(${this.accountTypes.selectedAccount.broker_name} - ${this.accountTypes.selectedAccount.account_number}) ${this.product.strategy_id} - ${this.product.strategy_name}`,
        noninteraction: false, // Optional
      });
    },

    trackDetails() {
      this.$gtm.trackEvent({
        event: "interaction", // Event type [default = 'interaction'] (Optional)
        category: "Detalhes de produto",
        action: "click",
        label: "Visualização de detalhes do produto",
        value: `(${this.accountTypes.selectedAccount.broker_name} - ${this.accountTypes.selectedAccount.account_number}) ${this.product.strategy_id} - ${this.product.strategy_name}`,
        noninteraction: false, // Optional
      });
    },

    unobserve() {
      this.observer.unobserve(this.$el);
    },

    activeStatistics(value) {
      this.menuStatistics.forEach((item) => {
        item.active = false;
      });
      value.active = true;

      this.getStatistics(this.strategy_id, value);
    },
    getSelectedMenuStatistics() {
      let analysisItem = "Total";

      const { label } = this.analysisOptions.find(({ id }) => id === this.analysis_id);

      if (label === typeOfAnalysis.TOTAL_PERIOD) analysisItem = "Total";
      if (label === typeOfAnalysis.PAPER_TRADE) analysisItem = "Paper trade";
      if (label === typeOfAnalysis.BACKTEST) analysisItem = "Backtest";
      if (label === typeOfAnalysis.CUSTOM_PERIOD) analysisItem = "Personalizado";

      return analysisItem;
    },
    // Obtido quando alterado a tab de estatística.
    getStatistics(strategyId, item) {
      let builderQuery = `${this.$endpoint.GET_STRATEGIES_PERFORMANCE_V2}/${strategyId}?`;
      let dataPeriod = "TOTAL";

      if (item.label === "Total") dataPeriod = "TOTAL";
      if (item.label === "Backtest") dataPeriod = "BACKTEST";
      if (item.label === "Paper trade") dataPeriod = "PAPER_TRADE";
      if (item.label === "Personalizado") dataPeriod = "CUSTOM_PERIOD";

      if (dataPeriod != "CUSTOM_PERIOD") {
        builderQuery += `data_period=${dataPeriod}`;
      } else {
        builderQuery += `start_datetime=${this.select_period.start}`;
        builderQuery += `&end_datetime=${this.select_period.end}`;
      }

      this.$api
        .get(builderQuery)
        .then((res) => {
          this.product_statistic = res.data.statistics;
        })
        .catch((error) => {});
    },

    requestPerformanceV2ToHeatmap(strategyId, period) {
      let initialYear;

      let builderQuery = "";

      if (period.hasOwnProperty("start")) {
        initialYear = period.start.split("-")[0];

        this.periodHeatmap.start_period = period.start;
        this.periodHeatmap.end_period = period.end;

        this.select_period.start = period.start;
        this.select_period.end = period.end;
      } else {
        initialYear = period.year;

        if (period.month === "ALL") {
          let start_period = moment().year(period.year).startOf("year").format("YYYY-MM-DDTHH:mm:ss[Z]");
          let end_period = moment().year(period.year).endOf("year").format("YYYY-MM-DDTHH:mm:ss[Z]");
          this.periodHeatmap.start_period = start_period;
          this.periodHeatmap.end_period = end_period;

          this.select_period.start = start_period;
          this.select_period.end = end_period;
        } else {
          let month;
          if (period.month === "JAN") month = 0;
          if (period.month === "FEV") month = 1;
          if (period.month === "MAR") month = 2;
          if (period.month === "ABR") month = 3;
          if (period.month === "MAI") month = 4;
          if (period.month === "JUN") month = 5;
          if (period.month === "JUL") month = 6;
          if (period.month === "AGO") month = 7;
          if (period.month === "SET") month = 8;
          if (period.month === "OUT") month = 9;
          if (period.month === "NOV") month = 10;
          if (period.month === "DEZ") month = 11;

          let start_period = moment().year(period.year).month(month).startOf("month").format("YYYY-MM-DDTHH:mm:ss[Z]");
          let end_period = moment().year(period.year).month(month).endOf("month").format("YYYY-MM-DDTHH:mm:ss[Z]");

          this.periodHeatmap.start_period = start_period;
          this.periodHeatmap.end_period = end_period;

          this.select_period.start = start_period;
          this.select_period.end = end_period;
        }
      }

      builderQuery += `start_datetime=${this.periodHeatmap.start_period}`;
      builderQuery += `&end_datetime=${this.periodHeatmap.end_period}`;

      builderQuery += "&only_metrics=TRUE";

      this.$api
        .get(`${this.$endpoint.GET_STRATEGIES_PERFORMANCE_V2}/${strategyId}?${builderQuery}`)
        .then((res) => {
          const dates = this.getDateRange(
            moment().year(Number(initialYear)).startOf("year"),
            moment().year(Number(initialYear)).endOf("year")
          );

          let newHeatmap = dates.map((item) => ({
            datetime: item,
            result: null,
          }));

          newHeatmap.forEach((item, index) => {
            let temp = res.data.heatmap.find((item2) => item2.datetime === item.datetime);
            if (temp) {
              newHeatmap[index].result = Object(temp).hasOwnProperty("result") ? temp.result : temp.day_result;
            }
          });

          this.heatmap_every_year = newHeatmap;

          const filteredByYear = newHeatmap.filter((item) => item.datetime.includes(initialYear));

          let newArr = [];
          filteredByYear.forEach((item) => newArr.push([item.datetime, item.result]));

          this.heatmapChart.data = newArr;

          const data_equity_curve = res.data.equity_curve.filter(
            (item) => !Object(item).hasOwnProperty("paper_trade_first_date")
          );

          if (this.page === "Operações") {
            this.listOperationsV2(this.strategy_id, {
              start_period: this.periodHeatmap.start_period,
              end_period: this.periodHeatmap.end_period,
            });
          }

          // Dados de estatísticas
          this.product_statistic = res.data.statistics;

          this.equity_curve = data_equity_curve;
          const findSplit = res.data.equity_curve.find((item) => Object(item).hasOwnProperty("paper_trade_first_date"));

          if (findSplit) {
            this.split_equity_curve = findSplit.paper_trade_first_date;
          } else {
            this.split_equity_curve = null;
          }
        })
        .catch((error) => {});
    },

    // Traz os dados dinâmicos da estratégia no aero.
    requestPerformanceV2(strategyId) {
      let dataPeriod = "TOTAL";

      const item = this.analysisOptions.find(({ id }) => id === this.analysis_id);

      if (item.label === typeOfAnalysis.TOTAL_PERIOD) dataPeriod = "TOTAL";
      if (item.label === typeOfAnalysis.BACKTEST) dataPeriod = "BACKTEST";
      if (item.label === typeOfAnalysis.PAPER_TRADE) dataPeriod = "PAPER_TRADE";
      if (item.label === typeOfAnalysis.CUSTOM_PERIOD) dataPeriod = "CUSTOM_PERIOD";

      let builderQuery = "";
      if (dataPeriod != "CUSTOM_PERIOD") {
        builderQuery += `data_period=${dataPeriod}`;
      } else {
        builderQuery += `start_datetime=${this.select_period.start}`;
        builderQuery += `&end_datetime=${this.select_period.end}`;
      }

      this.$api
        .get(`${this.$endpoint.GET_STRATEGIES_PERFORMANCE_V2}/${strategyId}?${builderQuery}`)
        .then((res) => {
          const data_equity_curve = res.data.equity_curve.filter(
            (item) => !Object(item).hasOwnProperty("paper_trade_first_date")
          );

          if (dataPeriod != "CUSTOM_PERIOD") {
            this.select_period.start = moment(data_equity_curve[0].datetime)
              .startOf("day")
              .format("YYYY-MM-DDTHH:mm:ss[Z]");
            this.select_period.end = moment(data_equity_curve[data_equity_curve.length - 1].datetime)
              .endOf("day")
              .format("YYYY-MM-DDTHH:mm:ss[Z]");
          }

          // Dados de estatísticas
          this.product_statistic = res.data.statistics;

          this.equity_curve = data_equity_curve;
          const findSplit = res.data.equity_curve.find((item) => Object(item).hasOwnProperty("paper_trade_first_date"));

          if (this.page === "Operações") {
            this.listOperationsV2(this.strategy_id, {
              start_period: this.select_period.start,
              end_period: this.select_period.end,
            });
          }

          if (findSplit) {
            this.split_equity_curve = findSplit.paper_trade_first_date;
          } else {
            this.split_equity_curve = null;
          }
        })
        .catch((error) => {});
    },

    // Traz os dados estático da estratégia no aero.
    requestDetailsV2(id) {
      this.$api
        .get(`${this.$endpoint.GET_STRATEGIES_INFO_V2}/${id}`)
        .then((res) => {
          this.product = {
            ...res.data,
            product_description: JSON.parse(res.data.product_description),
          };
        })
        .catch((error) => {});
    },

    /**
     * @param strategyId id da estratégia
     * @param dataView por default vem FIN_RESULT [Resultado Financeiro (R$)]
     * @param isQueryByDate é usado quando altero o período com a aba heatmap ativa, ao invés de pegar o último ano, pega a data selecionada.
     */
    getStatsV2(strategyId, dataView = this.resultTypePNLTable, isQueryByDate) {
      const builderEndpoint = `${this.$endpoint.GET_STRATEGIES_STATS_V2}/${strategyId}?data_view=${dataView}`;
      this.$api
        .get(builderEndpoint)
        .then((res) => {
          if (res.data.msg) {
            this.pnl_table = [];
            this.pnlError = res.data.msg;
          } else {
            this.pnlError = "";

            if (this.years_pnl_table.length === 0) {
              this.years_pnl_table = Object.keys(res.data);
            }

            let newArr = {};
            this.years_pnl_table.forEach((year) => {
              if (!newArr[year]) newArr[year] = {};

              newArr[year]["01"] = 0;
              newArr[year]["02"] = 0;
              newArr[year]["03"] = 0;
              newArr[year]["04"] = 0;
              newArr[year]["05"] = 0;
              newArr[year]["06"] = 0;
              newArr[year]["07"] = 0;
              newArr[year]["08"] = 0;
              newArr[year]["09"] = 0;
              newArr[year]["10"] = 0;
              newArr[year]["11"] = 0;
              newArr[year]["12"] = 0;
              newArr[year]["anual"] = 0;

              if (res.data && res.data[year]) {
                if (res.data[year]["01"]) newArr[year]["01"] = res.data[year]["01"];
                if (res.data[year]["02"]) newArr[year]["02"] = res.data[year]["02"];
                if (res.data[year]["03"]) newArr[year]["03"] = res.data[year]["03"];
                if (res.data[year]["04"]) newArr[year]["04"] = res.data[year]["04"];
                if (res.data[year]["05"]) newArr[year]["05"] = res.data[year]["05"];
                if (res.data[year]["06"]) newArr[year]["06"] = res.data[year]["06"];
                if (res.data[year]["07"]) newArr[year]["07"] = res.data[year]["07"];
                if (res.data[year]["08"]) newArr[year]["08"] = res.data[year]["08"];
                if (res.data[year]["09"]) newArr[year]["09"] = res.data[year]["09"];
                if (res.data[year]["10"]) newArr[year]["10"] = res.data[year]["10"];
                if (res.data[year]["11"]) newArr[year]["11"] = res.data[year]["11"];
                if (res.data[year]["12"]) newArr[year]["12"] = res.data[year]["12"];
                if (res.data[year]["anual"]) newArr[year]["anual"] = res.data[year]["anual"];
              }
            });

            var table_month = [];

            Object.keys(newArr).forEach((_year, index) => {
              var temp_month = new Array(13);

              Object.keys(newArr[_year]).forEach((_month, index) => {
                const isObject = newArr[_year][_month] != 0;

                if (_month === "01" && isObject) temp_month[0] = newArr[_year][_month];
                if (_month === "02" && isObject) temp_month[1] = newArr[_year][_month];
                if (_month === "03" && isObject) temp_month[2] = newArr[_year][_month];
                if (_month === "04" && isObject) temp_month[3] = newArr[_year][_month];
                if (_month === "05" && isObject) temp_month[4] = newArr[_year][_month];
                if (_month === "06" && isObject) temp_month[5] = newArr[_year][_month];
                if (_month === "07" && isObject) temp_month[6] = newArr[_year][_month];
                if (_month === "08" && isObject) temp_month[7] = newArr[_year][_month];
                if (_month === "09" && isObject) temp_month[8] = newArr[_year][_month];
                if (_month === "10" && isObject) temp_month[9] = newArr[_year][_month];
                if (_month === "11" && isObject) temp_month[10] = newArr[_year][_month];
                if (_month === "12" && isObject) temp_month[11] = newArr[_year][_month];
              });

              if (newArr[_year]["anual"]) temp_month[12] = newArr[_year]["anual"];
              table_month.push(temp_month);
            });

            this.pnl_table = table_month;

            if (this.selectedTypeChart === "Heatmap") {
              let _year = this.heatmapChart.periodYear;

              let periodYearIsAll = false;
              if (this.heatmapChart.periodYear === "ALL") {
                const allYears = Object.keys(res.data);
                const year = allYears[allYears.length - 1];
                this.heatmapChart.periodYear = year;
                _year = year;
                periodYearIsAll = true;
              }

              if (isQueryByDate) {
                this.requestPerformanceV2ToHeatmap(this.strategy_id, {
                  start: this.select_period.start,
                  end: this.select_period.end,
                });
              } else {
                this.requestPerformanceV2ToHeatmap(this.strategy_id, {
                  year: _year,
                  month: this.heatmapChart.periodMonth,
                });
              }
            }
          }
        })
        .catch((error) => {});
    },

    changePage(page) {
      this.paginationCurrentPage = page;

      if (
        this.page === "Operações" &&
        this.heatmapChart.periodYear === "ALL" &&
        this.heatmapChart.periodMonth === "ALL"
      ) {
        const { start: start_period, end: end_period } = this.select_period;
        this.listOperationsV2(this.strategy_id, { start_period, end_period }, page);
      } else {
        // this.listOperationsV2(this.strategy_id, this.periodHeatmap, page);
        const { start: start_period, end: end_period } = this.select_period;
        this.listOperationsV2(this.strategy_id, { start_period, end_period }, page);
      }
    },

    listOperationsV2(id, period, page = this.paginationCurrentPage) {
      const item = this.analysisOptions.find(({ id }) => id === this.analysis_id);

      let data_period;
      // Em "Período personalizado" não devo passar data_period
      if (item?.label === typeOfAnalysis.TOTAL_PERIOD) data_period = "TOTAL";
      if (item?.label === typeOfAnalysis.BACKTEST) data_period = "BACKTEST";
      if (item?.label === typeOfAnalysis.PAPER_TRADE) data_period = "PAPER_TRADE";
      // Não tem esse filtro na api de operações, devo enviar apenas o start_datetime e end_datetime.
      if (item?.label === typeOfAnalysis.CUSTOM_PERIOD) data_period = "CUSTOM_PERIOD";

      let start_datetime;
      let end_datetime;

      if (period && typeof period === "object") {
        start_datetime = period.start_period;
        end_datetime = period.end_period;
      } else {
        start_datetime = this.select_period.start;
        end_datetime = this.select_period.end;
      }

      let builderUrl = "";
      builderUrl += `page=${page}`;
      if (
        data_period === "CUSTOM_PERIOD"
        // this.heatmapChart.periodMonth != "ALL" ||
        // this.heatmapChart.periodYear != "ALL"
      ) {
        builderUrl += `&start_datetime=${start_datetime}`;
        builderUrl += `&end_datetime=${end_datetime}`;
      } else {
        builderUrl += `&data_period=${data_period}`;
      }

      this.$api
        .get(`${this.$endpoint.GET_STRATEGIES_OPERATIONS_V2}/${id}?${builderUrl}`)
        .then((res) => {
          this.orders_position = res.data;
        })
        .catch((error) => {
          this.orders_position = {};
        });
    },

    colorStatus(value) {
      let color = "";
      if (value == "STRATEGY") {
        color = `bg-ontick-orange-900 dark:text-ontick-orange-500 text-gray-50`;
      } else if (value == "PORTFOLIO") {
        color = `bg-ontick-lime-900 dark:text-ontick-lime-500 text-gray-50`;
      } else if (value == "SIGNAL") {
        color = `bg-ontick-blue-900 dark:text-ontick-blue-500 text-gray-50`;
      }
      return color;
    },
    colorStyle(value) {
      let color = "";
      if (value == "DAY_TRADE") {
        color = `bg-ontick-orange-900 dark:text-ontick-orange-500 text-gray-50`;
      } else if (value == "SWING_TRADE") {
        color = `bg-ontick-blue-900 dark:text-ontick-blue-500 text-gray-50`;
      }
      return color;
    },

    statusColor(value) {
      let color;
      if (value < 0) {
        color = "text-ontick-red-500";
      } else if (value == 0) {
        color = "dark:text-gray-400 text-ontick-carbon-900";
      } else {
        color = "text-ontick-green-500";
      }
      return color;
    },
    dateSelected(date) {
      this.select_period = {
        start: moment(new Date(this.select_period.start)).format("YYYY-MM-DDTHH:mm:ss[Z]"),
        end: moment(new Date(this.select_period.end)).format("YYYY-MM-DDTHH:mm:ss[Z]"),
      };

      EventBus.$emit("RESET_TABLE_PNL");

      if (this.analysis_id != 4) {
        this.analysis_id = 4; //Período personalizado
        this.listOperationsV2(this.strategy_id);
      } else {
        this.requestPerformanceV2(this.strategy_id);
        this.listOperationsV2(this.strategy_id);
        this.getStatsV2(this.strategy_id, this.resultTypePNLTable, true);
      }
    },
    analysisSelect(analysis) {
      this.paginationCurrentPage = 1;
      this.analysis_id = analysis.id;

      // Se for diferente de "Perído personalizado", então limpa o item ativo na tabela de PNL.
      if (analysis.id != 4) {
        EventBus.$emit("RESET_TABLE_PNL");
        const lastYear = this.years_pnl_table[this.years_pnl_table.length - 1];
        this.heatmapChart.periodMonth = "ALL";
        this.heatmapChart.periodYear = lastYear;
      }
    },

    async selectedPeriod({ year, month }) {
      let analysis_id_is_custom_period = this.analysis_id === 4;

      if (year != "ALL" && month === "ALL") {
        let start_period = moment().year(year).startOf("year").startOf("month").format("YYYY-MM-DDTHH:mm:ss[Z]");
        let end_period = moment().year(year).endOf("year").endOf("month").format("YYYY-MM-DDTHH:mm:ss[Z]");

        this.select_period.start = start_period;
        this.select_period.end = end_period;
      } else if (year != "ALL" || month != "ALL") {
        let start_period = moment().year(year).month(month).startOf("month").format("YYYY-MM-DDTHH:mm:ss[Z]");
        let end_period = moment().year(year).month(month).endOf("month").format("YYYY-MM-DDTHH:mm:ss[Z]");

        this.select_period.start = start_period;
        this.select_period.end = end_period;
      }

      this.paginationCurrentPage = 1;
      this.analysis_id = 4; //Campo "análise" passa a ser "período personalizado"

      if (year === "ALL" && month === "ALL") {
        const resetYear = this.years_pnl_table[this.years_pnl_table.length - 1];
        this.heatmapChart.periodYear = resetYear;
        this.heatmapChart.periodMonth = month;

        // Se já está como "período personalizado", porém,
        // foi desmarcado na tabela de pnl, volto para período "total"
        if (this.analysis_id === 4) {
          this.analysis_id = 1;
        }
      } else {
        if (analysis_id_is_custom_period) {
          await this.requestPerformanceV2ToHeatmap(this.strategy_id, {
            year,
            month,
          });
        }
        this.heatmapChart.periodYear = year;
        this.heatmapChart.periodMonth = month;
      }
    },
    getAnalysisType() {
      const item = this.analysisOptions.find(({ id }) => id === this.analysis_id);
      return item.label;
    },
    selectedChart({ chart: typeChart }) {
      this.selectedTypeChart = typeChart;
      // Reseta o dropdown de análise
      this.paginationCurrentPage = 1;
      if (typeChart === "Heatmap") {
        if (this.analysis_id === 4) {
          this.requestDetailsV2(this.strategy_id);
          if (this.selectedTypeChart != "Heatmap") {
            this.requestPerformanceV2(this.strategy_id);
          }
          this.getStatsV2(this.strategy_id);
        } else {
          this.analysis_id = 4; //"watch" executará de executar as funções acima.
        }
      }
    },
    changeTablePNL({ tableResultPNL }) {
      this.resultTypePNLTable = tableResultPNL;
      this.requestPerformanceV2(this.strategy_id);
      this.getStatsV2(this.strategy_id, tableResultPNL);

      if (this.analysis_id === 4) {
        EventBus.$emit("RESET_TABLE_PNL");
        const lastYear = this.years_pnl_table[this.years_pnl_table.length - 1];
        this.heatmapChart.periodMonth = "ALL";
        this.heatmapChart.periodYear = lastYear;
      }
    },
  },

  unmounted() {
    this.product = {};
    this.product_statistic = {};
    this.heatmap_every_year = [];
    this.equity_curve = [];
    this.split_equity_curve = null;
    this.pnl_table = [];
    this.years_pnl_table = [];
    this.heatmapChart = {
      data: [],
      periodYear: "ALL",
      periodMonth: "ALL",
    };
  },
};
</script>

<style lang="scss">
@import "./product.component.scss";

.companyy {
  &-move {
    transition: all 300ms ease-in-out 50ms;
  }
  &-enter-active {
    transition: all 100ms ease-out;
  }

  &-leave-active {
    transition: all 100ms ease-in;
    position: absolute;
    z-index: 0;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
  }
  &-enter {
    // transform: scale(0.9);
    opacity: 4;
  }
}

section {
  scroll-margin-top: 9rem;
}

.card {
  @apply dark:bg-ontick-graphite-500 rounded-md bg-gray-50 px-6 py-6 shadow-md;
}

.active {
  @apply text-ontick-blue-700 dark:text-gray-300 #{!important};
}

h3 {
  @apply text-base;
}

h4 {
  @apply text-sm;
}
.ghost-button {
  @apply mb-10 inline-flex w-full cursor-not-allowed items-center justify-center space-x-2 rounded-md border px-6 py-3 text-sm font-medium uppercase shadow-lg transition-all duration-150 ease-in-out focus:outline-none;
}
</style>
